<template>
  <v-layout
    v-show="value"
    row
    justify-center
    @click="$emit('input', !value)"
  >
    <v-dialog
      v-model="value"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
         {{ strings.areYouSure }}
        </v-card-title>
        <v-card-text>{{ strings.wouldYouLikeToContinue }} {{ action }}?</v-card-text>
        <v-text-field
          class="pl-2 pr-2"
          v-model="comment"
          outlined
          :label="strings.comment"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="onNo"
          >
            {{ strings.no }}
          </v-btn>
          <v-btn
            v-if="comment.length > 4"
            color="secondary"
            flat
            @click="onYes"
          >
            {{ strings.yes }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  props: ["value", "action"],
  data() {
    return {
      dialog: true,
      comment: "",
    };
  },
  computed: {
    ...mapGetters("page", ["strings"])
  },
  methods: {
    onNo() {
      this.$emit("input", false);
      this.$emit("answer", false);
    },
    onYes() {
      this.$emit("input", false);
      this.$emit("answer", {
        answer: true,
        comment: this.comment
      });
    }
  }
};
</script>

<style scoped></style>
